import React, { FC, useState, ChangeEvent } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import styles from './UploadPhoto.module.scss'

type Props = {
    defaultPhotoUrl?: string
    onChange?: (file: File) => void
}

const UploadPhoto: FC<Props> = ({ defaultPhotoUrl = '', onChange }) => {
    const { t } = useTranslation()
    const [url, setUrl] = useState(defaultPhotoUrl)

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files || event.target.files.length < 0) {
            return
        }

        const file = event.target.files[0]

        const reader = new FileReader()
        reader.onloadend = function (event) {
            if (
                !event.target ||
                !event.target.result ||
                typeof event.target.result !== 'string'
            ) {
                return null
            }

            setUrl(event.target.result)
        }

        reader.readAsDataURL(file)

        if (onChange) {
            onChange(file)
        }
    }

    return (
        <label
            className={classNames(styles.root, { [styles.showPhoto]: !!url })}
        >
            <input
                type="file"
                className={styles.input}
                onChange={handleFileChange}
            />

            <span className={styles.label}>
                {t('466_UploadPhoto_uploadPhoto')}
            </span>
            <span className={styles.formats}>
                {t('467_UploadPhoto_formats')}
            </span>

            {url && (
                <span
                    className={styles.photo}
                    style={{ backgroundImage: `url("${url}")` }}
                />
            )}
        </label>
    )
}

export default UploadPhoto
